<template>
    <v-dialog persistent max-width="764" v-model="dialog">
        <v-form ref="form" action="/report/promoter/download/">
            <v-card>
                <v-card-title>Download Promoter Listing</v-card-title>
                <v-card-text class="pb-0 my-1">
                    <input type="hidden" name="project" :value="object.project" />
                    <input type="hidden" name="start_date" :value="object.start_date" />
                    <input type="hidden" name="end_date" :value="object.end_date" />
                    <span class="text-subtitle-1">Are you sure that you want to download the promoter listing?</span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="close">Later</v-btn>
                    <v-btn text color="primary" @click="download">Download</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>


<script>

export default {
    name: 'PromoterListingDownload',
    data() {
        return {
            dialog: false,
            object: {}
        }
    },
    computed: {
        form() {
            return this.$refs.form
        }
    },
    methods: {
        open: function() {
            this.dialog = true
        },
        close: function() {
            this.dialog = false
        },
        updateObject: function(item) {
            this.object = item
        },
        download: function() {
            this.form.$el.submit()
            this.close()
            this.$emit('downloaded')
        },
    }
}

</script>